import axios from "axios";
import { useState, useCallback } from "react";
import { useAlert } from "./useAlert";

const API_URL = process.env.REACT_APP_API_URL;

export function useNotes() {
    const [notes, setNotes] = useState([]);
    const { showAlert } = useAlert();

    const fetchNotes = useCallback(async (id) => {
        try {
            const res = await axios.get(
                `${API_URL}/customers/customer/${id}/notes`, 
                { withCredentials: true }
            );
            setNotes(res.data.notes);
        } catch (error) {
            showAlert('Fehler beim Laden der Notizen.', 'error');
        }
    }, []);

    const deleteNote = async (id, noteId, setAlert) => {
        const confirmDelete = window.confirm('Möchtest du die Notiz wirklich löschen?');
        if (!confirmDelete) return;

        try {
            await axios.delete(
                `${API_URL}/customers/customer/${id}/notes/${noteId}`,
                { withCredentials: true }
            );
            showAlert('Notiz erfolgreich gelöscht', 'success');
            setNotes((prevNotes) => prevNotes.filter((note) => note._id !== noteId));
        } catch (error) {
            showAlert(error.response?.data?.message || error.message, 'error');
        }
    }

    const editNote = async (id, noteId, setAlert) => {
        const updatedNote = prompt('Bitte die neue Notiz eingeben:');
        if (!updatedNote) return;

        try {
            await axios.patch(
                `${API_URL}/customers/customer/${id}/notes/${noteId}`,
                { note: updatedNote },
                { withCredentials: true }
            );
            showAlert('Notiz erfolgreich aktualisiert', 'success');
            setTimeout(() => window.location.reload(), 1000);
        } catch (error) {
            showAlert(error.response?.data?.message || error.message, 'error');
        }
    }

    const saveNote = async (id, noteText, setAlert) => {
        if (!noteText) {
            showAlert('Bitte füll das Feld aus.', 'error');
            return;
        }

        try {
            const res = await axios.post(
                `${API_URL}/customers/customer/${id}/notes`,
                { note: noteText },
                { withCredentials: true }
            );

            if (res.data.status === 'success') {
                const updatedNotes = res.data.data.customer.details; // Extrahiere alle Notizen
                showAlert('Notiz erfolgreich erstellt', 'success');
                setNotes(updatedNotes); // Aktualisiere die gesamte Notizenliste
            }
        } catch (error) {
            showAlert(error.response?.data?.message || error.message, 'error');
        }
    };

    return { fetchNotes, notes, deleteNote, editNote, saveNote }
}